/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
import React from 'react';

import {
  Skeleton,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';

import { COLOR } from '../../../helpers/colors';
import { returnCountArr } from '../../../helpers/functions';

const textBox = <Skeleton variant="text" animation="wave" color={COLOR.PH} />;

const OrderDetailsPlaceholder = () => (
  <Grid sx={{ marginY: 6 }}>
    <Grid
      style={{
        border: `1px solid ${COLOR.borderColor}`,
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
      }}
    >
      <Grid
        item
        xs={12}
        container
        direction="row"
        justifyContent="center"
        sx={{
          background: COLOR.textColor,
          color: COLOR.whiteTextColor,
          padding: 3,
          textTransform: 'uppercase',
          borderTopLeftRadius: 5,
          borderTopRightRadius: 5,
        }}
      >
        {textBox}
      </Grid>
      <Grid
        item
        xs={12}
        container
        direction="row"
        justifyContent="space-between"
        sx={{ paddingY: 2, paddingX: 1, background: COLOR.bgColor }}
      >
        <Grid item xs={2}>
          {textBox}
          {textBox}
          {textBox}
        </Grid>
        <Grid item xs={2}>
          {textBox}
          {textBox}
          {textBox}
          {textBox}
        </Grid>
        <Grid item xs={2}>
          {textBox}
          {textBox}
          {textBox}
          {textBox}
        </Grid>
      </Grid>
    </Grid>

    <Grid container justifyContent="space-between" alignItems="center" mt={2}>
      <Grid container justifyContent="space-between" alignItems="center" mt={2}>
        <Grid item xs={1}>
          {textBox}
        </Grid>
      </Grid>
      <TableContainer>
        <Table aria-label="simple table">
          <TableHead sx={{ borderTop: `1px solid ${COLOR.borderColor}` }}>
            <TableRow>
              <TableCell
                align="left"
                sx={{
                  paddingY: 2,
                  paddingX: 1.5,
                }}
              >
                {textBox}
              </TableCell>
              <TableCell
                align="right"
                sx={{
                  paddingY: 2,
                  paddingX: 1.5,
                }}
              >
                {textBox}
              </TableCell>
              <TableCell
                align="right"
                sx={{
                  paddingY: 2,
                  paddingX: 1.5,
                }}
              >
                {textBox}
              </TableCell>
              <TableCell
                align="right"
                sx={{
                  paddingY: 2,
                  paddingX: 1.5,
                }}
              >
                {textBox}
              </TableCell>
              <TableCell
                align="right"
                sx={{
                  paddingY: 2,
                  paddingX: 1.5,
                }}
              >
                {textBox}
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {[0].map(rowIndex => {
              return (
                <TableRow>
                  <TableCell
                    align="right"
                    sx={{
                      paddingY: 2,
                      paddingX: 1.5,
                    }}
                  >
                    {rowIndex === 0 ? textBox : null}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      paddingY: 2,
                      paddingX: 1.5,
                    }}
                  >
                    {rowIndex === 0 ? textBox : null}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      paddingY: 2,
                      paddingX: 1.5,
                    }}
                  >
                    {rowIndex === 0 ? textBox : null}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      paddingY: 2,
                      paddingX: 1.5,
                    }}
                  >
                    {rowIndex === 0 ? (
                      <>
                        {textBox}
                        {textBox}
                        {textBox}
                      </>
                    ) : null}
                  </TableCell>

                  <TableCell
                    align="right"
                    sx={{
                      paddingY: 2,
                      paddingX: 1.5,
                    }}
                  >
                    {rowIndex === 0 ? textBox : null}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>

    <TableContainer>
      <Table>
        <TableBody>
          <Grid container justifyContent="space-between" alignItems="center" mt={1}>
            <Grid item xs={1}>
              {textBox}
            </Grid>
          </Grid>
        </TableBody>
      </Table>
    </TableContainer>
    <Grid container justifyContent="center" alignItems="center" mt={1}>
      <Grid item xs={1}>
        {textBox}
      </Grid>
    </Grid>
  </Grid>
);

export default OrderDetailsPlaceholder;
